<template>
  <section class="info-section sz-red sz-white--text">
    <h2 class="section-heading mb-0 text-h2 font-weight-medium text-center">
      {{ $t('home.infoSection.title') }}
    </h2>
    <h3 class="section-heading mt-0 font-weight-medium text-center">
      {{ $t('home.infoSection.subtitle') }}
    </h3>
    <InfoSectionTiles class="info-section__tiles" />
  </section>
</template>

<script setup lang="ts">
import InfoSectionTiles from './InfoSectionTiles.vue'
</script>

<style lang="scss">
@use '@/assets/css/variables.scss' as variables;
@use 'sass:map';

.info-section {
  .info-section__tiles {
    margin: 0 16px var(--section-heading-gap);

    @media screen and (min-width: map.get(variables.$grid-breakpoints, 'xl')) {
      margin: 0 32px var(--section-heading-gap);
    }
  }
}
</style>
